import { i18next } from '@/i18n'
import axios from 'axios'
import { authHeader } from '@/services/auth'

export default {
  namespaced: true,
  state: {
    posts: [],
    urls: [],
    quotaMax: 0,
    nbClapRestants: 0,
    nbClapGeneres: 0,
    clapInProgress: false, // État global (gardé pour compatibilité ManagePostNetwork.vue)
    clapInProgressByPost: [] // État par post [{ postId: 123, inProgress: true }]
  },
  actions: {
    checkQuotaClap (context, args) {
      const { universe, possedeClap } = args
      if (possedeClap) {
        let url = processEnvConfig.VUE_APP_UBIFLOW_API_URL + '/diffusion_annonceur?' + 'diffuseur-codeNames=' + `CLAP_VIDEO_${universe}`
        if (i18next.language != null) {
          url += '&lang=' + i18next.language
        }
        return axios.get(url, { headers: authHeader() }).then((response) => {
          const diffusionClap = response.data
          if (diffusionClap) {
            const diffusionAnnonceurClapVideo = response.data._embedded.diffusion_annonceur
            if (diffusionAnnonceurClapVideo[0].identifiants[4].valeur) {
              context.commit('setQuotaMax', diffusionAnnonceurClapVideo[0].identifiants[4].valeur)
            }
            if (diffusionAnnonceurClapVideo[0].identifiants[5].valeur) {
              context.commit('setNbClapRestants', diffusionAnnonceurClapVideo[0].identifiants[5].valeur)
            }
            if (diffusionAnnonceurClapVideo[0].identifiants[6].valeur) {
              context.commit('setNbClapGeneres', diffusionAnnonceurClapVideo[0].identifiants[6].valeur)
            }
          }
        })
      }
    }
  },
  mutations: {
    setPostStatus (state, post) {
      if (post) {
        const existingIndex = state.posts.findIndex((item) => item.id === post.id)
        if (existingIndex !== -1) {
          // Remplacer le post existant
          state.posts.splice(existingIndex, 1, post)
        } else {
          // Ajouter un nouveau post
          state.posts.push(post)
        }
      }
    },
    setUrlClap (state, payload) {
      if (payload) {
        const existingIndex = state.urls.findIndex((item) => item.annonceId === payload.id)

        if (existingIndex !== -1) {
          // Mettre à jour l'URL existante
          state.urls.splice(existingIndex, 1, { annonceId: payload.id, url: payload.url_clap })
        } else {
          // Ajouter une nouvelle URL
          state.urls.push({ annonceId: payload.id, url: payload.url_clap })
        }
      }
    },
    setClapInProgressByPost (state, payload) {
      if (payload && payload.postId !== undefined) {
        const existingIndex = state.clapInProgressByPost.findIndex((item) => item.postId === payload.postId)

        if (existingIndex !== -1) {
          // Mettre à jour l'état existant
          state.clapInProgressByPost.splice(existingIndex, 1, { postId: payload.postId, inProgress: payload.inProgress })
        } else {
          // Ajouter un nouvel état
          state.clapInProgressByPost.push({ postId: payload.postId, inProgress: payload.inProgress })
        }
      }
    },
    deletePost (state, post) {
      state.clapInProgress = false
      const existPost = state.posts.findIndex((item) => item.id === post.id)
      if (existPost !== -1) {
        state.posts.splice(existPost, 1) // suppression réelle du tableau
      }

      // Nettoyer l'état clapInProgress pour ce post
      const existingProgressIndex = state.clapInProgressByPost.findIndex((item) => item.postId === post.id)
      if (existingProgressIndex !== -1) {
        state.clapInProgressByPost.splice(existingProgressIndex, 1)
      }
    },
    setQuotaMax (state, value) {
      state.quotaMax = value
    },
    setNbClapRestants (state, value) {
      state.nbClapRestants = value
    },
    setNbClapGeneres (state, value) {
      state.nbClapGeneres = value
    },
    setClapInProgress (state, value) {
      state.clapInProgress = value
    }
  },
  getters: {
    getHasPost: (state) => (post) => {
      return state.posts.find((item) => item.id == post.id)
    },
    getListPostsClap: (state) => state.posts,
    getPostClap: (state) => (post) => {
      return state.posts.filter((item) => item.id == post.id)
    },
    getQuotaMax: (state) => state.quotaMax,
    getNbClapRestants: (state) => state.nbClapRestants,
    getNbClapGeneres: (state) => state.nbClapGeneres,
    getHasUrlClap: (state) => (id) => {
      return state.urls.filter((item) => item.annonceId === id)
    },
    getClapInProgress: (state) => state.clapInProgress,
    getClapInProgressByPost: (state) => (postId) => {
      const postProgress = state.clapInProgressByPost.find((item) => item.postId === postId)
      return postProgress ? postProgress.inProgress : false
    }
  }
}
